var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderApi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.832 13.6001L11.1898 8.95783L13.1456 7.002C14.4275 5.72008 16.5059 5.72008 17.7879 7.002C19.0698 8.28392 19.0698 10.3623 17.7879 11.6442L15.832 13.6001Z",
    stroke: "#F2F6F9",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8408 11.5401L11.8594 10.5215",
    stroke: "#F2F6F9",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2039 6.78631L19.6406 5.34961",
    stroke: "#F2F6F9",
    strokeWidth: 1.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3368 14.0362L14.3555 13.0176",
    stroke: "#F2F6F9",
    strokeWidth: 1.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40625 11.9214L13.1007 16.6158L11.2003 18.5161C9.904 19.8125 7.80224 19.8125 6.50592 18.5161C5.20959 17.2198 5.20959 15.1181 6.50592 13.8217L8.40625 11.9214Z",
    stroke: "#F2F6F9",
    strokeWidth: 1.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13982 18.8787L4.70312 20.3154",
    stroke: "#F2F6F9",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderApi);
export default __webpack_public_path__ + "static/media/header-api.0ecbff41670c69f66b5a5169787877ea.svg";
export { ForwardRef as ReactComponent };